import React from 'react';
import styled from 'styled-components';
import mac from '../../../assets/mac-dark-gray.svg';
import windows from '../../../assets/windows-dark-gray.svg';
import DownloadButton from '../../../containers/Buttons/DownloadButton';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  flex-wrap: wrap;
`;

const Platform = styled.div`
  height: 100%;
  margin: 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Image = styled.div`
  margin: 20px;
 
  /* image */
  background-image: url(${props => props.src});
  
  /* make a square container */
  height: 100px;
  width: 100px;
  
  /* size: cover / contain */
  background-size: 100% 100%;

  /* center the image vertically and horizontally */
  background-position: center;
`;

class Download extends React.Component {
  render() {
    return (
      <Container>
        <Platform>
          <Image src={mac}/>
          <DownloadButton text="MAC"/>
        </Platform>
        <Platform>
          <Image src={windows}/>
          <DownloadButton text="WINDOWS"/>
        </Platform>
      </Container>
    )
  }
}

export default Download;




// WEBPACK FOOTER //
// ./src/components/PublicWebsite/Download/index.js